import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

// Connects to data-controller="slim-select"
export default class extends Controller {
  static targets = [ "selector" ]
  static values = { placeholder: String }

  connect() {
    new SlimSelect({
      select: this.selectorTarget,
      showSearch: true,
      settings: {
        allowDeselect: true,
        placeholderText: this.placeholderValue,
        searchText: 'Searching...',
      }
    })
  }
}
